import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'money',
})
export class MoneyPipe implements PipeTransform {
  transform(value: unknown, ...args: unknown[]): string {
    if (value === null || value === undefined) {
      return '';
    }

    let num: number;

    // value가 이미 숫자형인 경우
    if (typeof value === 'number') {
      num = value;
    }
    // value가 문자열인 경우, 숫자로 변환 시도
    else if (typeof value === 'string') {
      num = parseFloat(value);
    }
    // 기타 타입은 숫자로 강제 변환
    else {
      num = Number(value);
    }

    // 변환이 실패하면 원래 값을 문자열로 반환
    if (isNaN(num)) {
      return String(value);
    }

    // 숫자를 locale 형식의 문자열로 변환하여 3자리마다 쉼표 추가
    return num.toLocaleString('en-US');
  }
}
